import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {useParams} from 'react-router-dom';
import { UWData } from '@app_modules/admin/chats/requests/use-demo-uw';

const Endpoint = (id: number | string) => `loan-products/${id}/get-md-data-loan-program`;

export interface FetchMdResponse extends BackendResponse {
   md_data: string;
}

export function useMdDataLoanProgram() {
  const { id } = useParams();
  return useQuery({
    queryKey: [Endpoint( id!)],
    queryFn: () => fetchMdDataCondition( id!),
  });
}

function fetchMdDataCondition( id: number | string): Promise<FetchMdResponse> {
  return apiClient.get(Endpoint( id)).then(response => response.data);
}
